import React, { useEffect, useState } from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const sections = ['about', 'proof', 'techstack', 'services', 'projects', 'demo', 'approach', 'contact', 'legalnotice'];

const LogoIcon = () => (
  <svg viewBox="0 0 32 32" height="32" width="32" aria-hidden="true" style={{ flexShrink: 0 }}>
    <polygon
      points="16,1.5 28.5,8.5 28.5,23.5 16,30.5 3.5,23.5 3.5,8.5"
      fill="none"
      stroke="#1a73e8"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <line x1="16" y1="12" x2="16" y2="18" stroke="#1a73e8" strokeWidth="1.8" strokeLinecap="round" />
    <line x1="16" y1="18" x2="10.5" y2="21.5" stroke="#1a73e8" strokeWidth="1.8" strokeLinecap="round" />
    <line x1="16" y1="18" x2="21.5" y2="21.5" stroke="#1a73e8" strokeWidth="1.8" strokeLinecap="round" />
    <circle cx="16" cy="10" r="2.2" fill="#1a73e8" />
    <circle cx="10.5" cy="23" r="2.2" fill="#1a73e8" />
    <circle cx="21.5" cy="23" r="2.2" fill="#1a73e8" />
  </svg>
);

const Navigation = () => {
  const { t, i18n } = useTranslation();
  const [active, setActive] = useState('');
  const [expanded, setExpanded] = useState(false);

  const changeLang = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('lang', lang);
    setExpanded(false);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter(entry => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio);

        let current = '';
        if (visible.length > 0) {
          current = visible[0].target.getAttribute('id');
        } else if (window.scrollY < 200) {
          current = 'about';
        }

        if (current !== active) setActive(current);
      },
      { root: null, threshold: [0.1, 0.25, 0.5, 0.75, 1.0] }
    );

    sections.forEach(id => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [active]);

  const scrollTo = (e, id) => {
    e.preventDefault();
    setExpanded(false);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  const navLabel = (id) => {
    if (id === 'legalnotice') return t('nav.legalnotice');
    if (id === 'proof') return t('nav.proof');
    return t(`nav.${id}`);
  };

  return (
    <div className="w-100">
      <Navbar
        expand="lg"
        variant="light"
        fixed="top"
        collapseOnSelect
        expanded={expanded}
        onToggle={setExpanded}
        className="navbar-custom nav-stable"
      >
        <div className="container nav-stable-inner">
          <Navbar.Brand
            href="#about"
            onClick={(e) => scrollTo(e, 'about')}
            className="brand-center nav-stable-brand d-flex align-items-center gap-2"
            style={{ cursor: 'pointer' }}
          >
            <LogoIcon />
            <span className="brand-name">Alexander Aprelkin</span>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="responsive-navbar-nav" className="toggler-right nav-stable-toggle" />

          <Navbar.Collapse id="responsive-navbar-nav" className="nav-stable-collapse">
            <Nav className="pt-2 pt-lg-0 nav-stable-nav">
              {sections.map((id) => (
                <Nav.Link
                  key={id}
                  href={`#${id}`}
                  onClick={(e) => scrollTo(e, id)}
                  className={`nav-link ${active === id ? 'active' : ''}`}
                  data-target={id}
                >
                  <span className="mx-2">{navLabel(id)}</span>
                </Nav.Link>
              ))}
            </Nav>

            <div className="lang-switcher ms-lg-3">
              <button
                className={i18n.language === 'de' ? 'active' : ''}
                onClick={() => changeLang('de')}
                aria-label="Deutsch"
              >
                DE
              </button>
              <span aria-hidden="true">|</span>
              <button
                className={i18n.language === 'en' ? 'active' : ''}
                onClick={() => changeLang('en')}
                aria-label="English"
              >
                EN
              </button>
            </div>
          </Navbar.Collapse>
        </div>
      </Navbar>
    </div>
  );
};

export default Navigation;
